import styled, { keyframes } from 'styled-components';
import { propStyling, tombac } from 'tombac';
import { SpinnerIcon } from 'tombac-icons';
import { jsx as _jsx } from "react/jsx-runtime";
const fadeIn = keyframes(["from{opacity:0;}to{opacity:1;}"]);
const SpinnerContainer = styled.div.withConfig({
  displayName: "LoadingSpinner__SpinnerContainer"
})(["align-items:center;animation:0.2s ease-out 1s 1 both ", ";color:", ";display:flex;flex:1;justify-content:center;", ""], fadeIn, tombac.color('primary', 500), propStyling);
export const LoadingSpinner = _ref => {
  let {
    size = 2,
    ...stylingProps
  } = _ref;
  return /*#__PURE__*/_jsx(SpinnerContainer, {
    ...stylingProps,
    "data-sentry-element": "SpinnerContainer",
    "data-sentry-component": "LoadingSpinner",
    "data-sentry-source-file": "LoadingSpinner.tsx",
    children: /*#__PURE__*/_jsx(SpinnerIcon, {
      size: size,
      spin: true,
      "data-sentry-element": "SpinnerIcon",
      "data-sentry-source-file": "LoadingSpinner.tsx",
      "data-sentry-element": "SpinnerIcon"
    })
  });
};